export function compareStatusHistoryEntries(a, b, indexA = 0, indexB = 0) {
  const dateDiff = new Date(a?.Date || 0) - new Date(b?.Date || 0);
  if (dateDiff !== 0) return dateDiff;

  if (a?._id && b?._id) {
    return String(a._id).localeCompare(String(b._id));
  }

  return indexA - indexB;
}

export function getLatestStatusEntry(statusHistory = []) {
  if (!Array.isArray(statusHistory) || statusHistory.length === 0) return null;

  let latest = statusHistory[0];
  let latestIndex = 0;

  statusHistory.forEach((entry, index) => {
    if (compareStatusHistoryEntries(entry, latest, index, latestIndex) > 0) {
      latest = entry;
      latestIndex = index;
    }
  });

  return latest;
}

export function isLatestStatusEntry(statusEntry, statusHistory = [], latestStatusEntryId = '') {
  if (!statusEntry) return false;

  if (latestStatusEntryId && statusEntry._id) {
    return String(statusEntry._id) === String(latestStatusEntryId);
  }

  const latest = getLatestStatusEntry(statusHistory);
  if (!latest) return false;

  if (latest._id && statusEntry._id) {
    return String(latest._id) === String(statusEntry._id);
  }

  return latest.Status === statusEntry.Status
    && new Date(latest.Date || 0).getTime() === new Date(statusEntry.Date || 0).getTime();
}

export function sortStatusHistoryChronologically(statusHistory = []) {
  return [...statusHistory]
    .map((entry, index) => ({ entry, index }))
    .sort((a, b) => compareStatusHistoryEntries(a.entry, b.entry, a.index, b.index))
    .map(({ entry }) => entry);
}

/** Display order for Source Profile Details: newest status entry first (by entry Date/time). */
export function sortStatusHistoryNewestFirst(statusHistory = []) {
  const chronological = sortStatusHistoryChronologically(statusHistory);
  return chronological.reverse();
}

export function getStatusRemarkEntries(statusEntry) {
  if (!statusEntry) return [];

  const remarks = Array.isArray(statusEntry.Remarks) ? statusEntry.Remarks : [];
  const normalized = remarks
    .map((entry) => {
      const text = String(entry?.text || entry?.Remark || entry?.remark || '').trim();
      if (!text) return null;
      return {
        text,
        createdAt: entry?.createdAt || entry?.Date || entry?.date || statusEntry?.Date || null,
      };
    })
    .filter(Boolean);

  if (normalized.length > 0) {
    return normalized.sort(
      (a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0)
    );
  }

  const legacyRemark = String(statusEntry.Remark || statusEntry.remark || '').trim();
  if (!legacyRemark) return [];

  return [{
    text: legacyRemark,
    createdAt: statusEntry.Date || null,
  }];
}

export function mergeStatusEntryRemarkUpdate(existingEntry, updatedEntry) {
  if (!existingEntry || !updatedEntry) return existingEntry;
  return {
    ...existingEntry,
    ...updatedEntry,
    Remarks: getStatusRemarkEntries(updatedEntry),
  };
}

export function mergeCandidateStatusRemarkUpdate(candidate, statusEntryId, updatedStatusEntry) {
  if (!candidate?.Status) return candidate;
  return {
    ...candidate,
    Status: candidate.Status.map((entry) => (
      String(entry._id) === String(statusEntryId)
        ? mergeStatusEntryRemarkUpdate(entry, updatedStatusEntry)
        : entry
    )),
  };
}
